import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ApplicationPackage} from 'src/app/enums/application-package.enum';
import {Service} from 'src/app/enums/service.enum';
import {CustomHttpUrlEncodingCodec} from 'src/app/main/encoder';
import {PageOfVopKpiReportData} from 'src/app/model/cms-vod-core/vop-kpi-data-models/vop-kpi-data.model';
import {VodQueryParams} from 'src/app/model/vod-query-params.model';
import {environment} from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class VopKpiReportService {
  constructor(private http: HttpClient) {}

  readonly vopKpiDataUrl = environment.endPoint + ApplicationPackage.CMS_VOD + Service.VOP_KPI_DATA;

  getVopKpiData(queryParam?: VodQueryParams): Observable<PageOfVopKpiReportData> {
    let queryParams: HttpParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    queryParam.page = queryParam.page - 1;

    if (queryParam.page >= 0) {
      queryParams = queryParams.set('page', <any>queryParam.page);
    }
    if (queryParam.itemCount) {
      queryParams = queryParams.set('itemCount', <any>queryParam.itemCount);
    }
    if (queryParam.contentName) {
      queryParams = queryParams.set('contentName', <any>queryParam.contentName);
    }
    if (queryParam.contentGuid) {
      queryParams = queryParams.set('contentGuid', <any>queryParam.contentGuid);
    }
    if (queryParam.contentType) {
      queryParams = queryParams.set('contentType', <any>queryParam.contentType);
    }
    if (queryParam.finishTimeStart) {
      queryParams = queryParams.set('finishTimeStart', <any>queryParam.finishTimeStart);
    }
    if (queryParam.finishTimeEnd) {
      queryParams = queryParams.set('finishTimeEnd', <any>queryParam.finishTimeEnd);
    }
    if (queryParam.userId) {
      queryParams = queryParams.set('userId', <any>queryParam.userId);
    }
    if (queryParam.userName) {
      queryParams = queryParams.set('userName', <any>queryParam.userName);
    }
    if (queryParam.serviceType) {
      queryParams = queryParams.set('serviceType', <any>queryParam.serviceType);
    }
    if (queryParam.processName) {
      queryParams = queryParams.set('processName', <any>queryParam.processName);
    }

    return this.http.get<PageOfVopKpiReportData>(this.vopKpiDataUrl, {params: queryParams});
  }

  generateVopKpiDataReport(queryParam?: VodQueryParams): Observable<any> {
    let queryParams: HttpParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    queryParam.page = queryParam.page - 1;

    if (queryParam.page >= 0) {
      queryParams = queryParams.set('page', <any>queryParam.page);
    }
    if (queryParam.itemCount) {
      queryParams = queryParams.set('itemCount', <any>queryParam.itemCount);
    }
    if (queryParam.contentName) {
      queryParams = queryParams.set('contentName', <any>queryParam.contentName);
    }
    if (queryParam.contentGuid) {
      queryParams = queryParams.set('contentGuid', <any>queryParam.contentGuid);
    }
    if (queryParam.contentType) {
      queryParams = queryParams.set('contentType', <any>queryParam.contentType);
    }
    if (queryParam.finishTimeStart) {
      queryParams = queryParams.set('finishTimeStart', <any>queryParam.finishTimeStart);
    }
    if (queryParam.finishTimeEnd) {
      queryParams = queryParams.set('finishTimeEnd', <any>queryParam.finishTimeEnd);
    }
    if (queryParam.userId) {
      queryParams = queryParams.set('userId', <any>queryParam.userId);
    }
    if (queryParam.userName) {
      queryParams = queryParams.set('userName', <any>queryParam.userName);
    }
    if (queryParam.serviceType) {
      queryParams = queryParams.set('serviceType', <any>queryParam.serviceType);
    }
    if (queryParam.processName) {
      queryParams = queryParams.set('processName', <any>queryParam.processName);
    }

    return this.http.get<any>(this.vopKpiDataUrl + '/report', {params: queryParams});
  }
}
